import RichText from 'components/rich-text';
import dynamic from 'next/dynamic';

const Modal = dynamic(
  () => import('components/_shared/widgets/modal/with-close')
);

const CustomerDeliveryTimeModal = ({
  close,
  isOpen,
  description,
}: {
  close: () => void;
  isOpen: boolean;
  description: string;
}) => (
  <Modal
    title="When will I get my order?"
    close={close}
    isOpen={isOpen}
    iconSize={20}
    size="medium"
  >
    <RichText content={description} />
  </Modal>
);

export default CustomerDeliveryTimeModal;
